import React, { useState, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Select } from "antd";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";

const CountryCodePrompt = ({ visible, onClose, onConfirm, provider }) => {
  const [selectedCountryCode, setSelectedCountryCode] = useState("971");

  // Generate country code options from libphonenumber-js
  const countryCodeOptions = useMemo(() => {
    const countries = getCountries();
    const countryMap = new Map();

    // Country name mapping for better labels
    const countryNames = {
      US: "USA",
      GB: "UK",
      AE: "UAE",
      SA: "Saudi Arabia",
      IN: "India",
      PK: "Pakistan",
      QA: "Qatar",
      KW: "Kuwait",
      OM: "Oman",
      BH: "Bahrain",
      EG: "Egypt",
      JO: "Jordan",
      LB: "Lebanon",
      CN: "China",
      JP: "Japan",
      KR: "South Korea",
      SG: "Singapore",
      MY: "Malaysia",
      AU: "Australia",
      DE: "Germany",
      FR: "France",
      IT: "Italy",
      ES: "Spain",
      CA: "Canada",
      MX: "Mexico",
      BR: "Brazil",
      AR: "Argentina",
      ZA: "South Africa",
      NG: "Nigeria",
      KE: "Kenya",
      TR: "Turkey",
      RU: "Russia",
      NL: "Netherlands",
      BE: "Belgium",
      SE: "Sweden",
      NO: "Norway",
      DK: "Denmark",
      FI: "Finland",
      PL: "Poland",
      CH: "Switzerland",
      AT: "Austria",
      IE: "Ireland",
      NZ: "New Zealand",
      TH: "Thailand",
      ID: "Indonesia",
      PH: "Philippines",
      VN: "Vietnam",
      IL: "Israel",
    };

    countries.forEach((countryCode) => {
      try {
        const dialCode = getCountryCallingCode(countryCode);
        const countryName = countryNames[countryCode] || countryCode;

        // Group countries with same dial code
        if (!countryMap.has(dialCode)) {
          countryMap.set(dialCode, {
            value: dialCode,
            label: `+${dialCode} (${countryName})`,
            countries: [countryName],
          });
        } else {
          const existing = countryMap.get(dialCode);
          existing.countries.push(countryName);
          existing.label = `+${dialCode} (${existing.countries.join(", ")})`;
        }
      } catch (e) {
        // Skip countries without calling codes
      }
    });

    // Convert to array and sort by dial code
    return Array.from(countryMap.values()).sort((a, b) => {
      return parseInt(a.value) - parseInt(b.value);
    });
  }, []);

  const handleConfirm = () => {
    onConfirm(selectedCountryCode);
  };

  return (
    <Modal
      show={visible}
      onHide={onClose}
      centered
      backdrop="static"
      className="country-code-modal"
      style={{ zIndex: 1500 }}
      backdropClassName="country-code-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>Default Country Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              Select default country code for contacts without one
            </Form.Label>
            <Select
              style={{ width: "100%", zIndex: 1600 }}
              value={selectedCountryCode}
              onChange={(value) => setSelectedCountryCode(value)}
              options={countryCodeOptions}
              showSearch
              placeholder="Select country code"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
            <Form.Text className="text-muted">
              This country code will be applied to phone numbers that don't have
              one when importing from {provider}.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Continue Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CountryCodePrompt;
